import { useContext } from 'react';
import { ReportTrackerContext, type ReportTrackerContextValue } from '../context/ReportTrackerContextBase';

export const useReportTracker = (): ReportTrackerContextValue => {
  const context = useContext(ReportTrackerContext);
  if (!context) {
    throw new Error('useReportTracker must be used within a ReportTrackerProvider');
  }
  return context;
};
